import Arrow001Btn from "@assets/imgs/arrows/001-arrow-btn.png";
import Arrow002Btn from "@assets/imgs/arrows/002-arrow-btn.png";
import Arrow003Btn from "@assets/imgs/arrows/003-arrow-btn.png";
import Arrow004Btn from "@assets/imgs/arrows/004-arrow-btn.png";
import Arrow005Btn from "@assets/imgs/arrows/005-arrow-btn.png";
import Arrow006Btn from "@assets/imgs/arrows/006-arrow-btn.png";
import Arrow007Btn from "@assets/imgs/arrows/007-arrow-btn.png";
import Arrow008Btn from "@assets/imgs/arrows/008-arrow-btn.png";

export interface ArrowSkin {
  id: string;
  textureKey: string;

  price: number;

  defaultOwned?: boolean;
  defaultEquipped?: boolean;
}

export const ARROW_SKINS: ArrowSkin[] = [
  {
    id: "arrow-001",
    textureKey: "001-arrow-btn",
    price: 0,
    defaultOwned: true,
    defaultEquipped: true,
  },

  {
    id: "arrow-002",
    textureKey: "002-arrow-btn",
    price: 100,
  },
  {
    id: "arrow-003",
    textureKey: "003-arrow-btn",
    price: 100,
  },
  {
    id: "arrow-004",
    textureKey: "004-arrow-btn",
    price: 500,
  },
  {
    id: "arrow-005",
    textureKey: "005-arrow-btn",
    price: 500,
  },
  {
    id: "arrow-006",
    textureKey: "006-arrow-btn",
    price: 1000,
  },
  {
    id: "arrow-007",
    textureKey: "007-arrow-btn",
    price: 1000,
  },
  {
    id: "arrow-008",
    textureKey: "008-arrow-btn",
    price: 1000,
  },
];

export const ARROW_SKIN_BY_ID: Record<string, ArrowSkin> = Object.fromEntries(
  Object.values(ARROW_SKINS).map((skin) => [skin.id, skin]),
);

export function preloadArrowSkins(scene: Phaser.Scene) {
  scene.load.spritesheet("001-arrow-btn", Arrow001Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("002-arrow-btn", Arrow002Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("003-arrow-btn", Arrow003Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("004-arrow-btn", Arrow004Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("005-arrow-btn", Arrow005Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("006-arrow-btn", Arrow006Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("007-arrow-btn", Arrow007Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });

  scene.load.spritesheet("008-arrow-btn", Arrow008Btn, {
    frameWidth: 400,
    frameHeight: 300,
  });
}
